const isAchCompanyBalanced = achCompany =>
    achCompany?.batchBalanceRequirements?.toLowerCase().trim() === 'balanced';

export default isAchCompanyBalanced;
